import { useState } from "react";
// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

import SupportTableRow from "./SupportTableRow";

const SupportData = () => {
  const { supports, isLoading } = useSelector((state) => state.supports);
  const dispatch = useDispatch();

  const [supportData, setSupportData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <TableContainer sx={{ whiteSpace: "nowrap" }}>
      <Table aria-label='customized table'>
        <TableHead
          sx={{
            "&:hover": false,
          }}
        >
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by id'
                id='id-searchbox'
                label='Id'
                name='searchId'
                // onChange={handleSearch}
              />
            </TableCell>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by name'
                id='name-searchbox'
                label='User'
                name='searchuser'
                // onChange={handleSearch}
              />
            </TableCell>

            <TableCell>
              <TextField
                fullWidth
                helperText='Search by email'
                id='email-searchbox'
                label='Status'
                name='searchstatus'
                // onChange={handleSearch}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography variant='p' align='center'>
                  Loading...
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            <SupportTableRow row={supports}></SupportTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    // <Typography>Order data</Typography>
  );
};

export default SupportData;
